import { styled } from 'styled-components'

import { error } from 'core/styles'

const ErrorMessage = styled.p<{ color?: string; align?: string }>`
  margin: 8px 0;
  text-align: ${(props) => props.align ?? 'left'};
  color: ${(props) => props.color ?? error};
  font-size: 14px;
`

export default ErrorMessage
